import { defineComponent, ref } from 'vue';
import { Phone, Message, Location } from '@element-plus/icons-vue';
export default defineComponent({
  name: 'PageFooter',
  components: {
    Phone,
    Message,
    Location
  },
  setup() {
    const footerData = ref([{
      type: '0',
      title: 'label13',
      list: [{
        label: 'label16',
        link: '/about'
      }, {
        label: 'label18',
        link: '/honor'
      }]
    }, {
      type: '0',
      title: 'label14',
      list: [{
        label: 'kitchen.name',
        link: '/class/kitchen'
      }, {
        label: 'bathroom.name',
        link: '/class/bathroom'
      }, {
        label: 'water_saving.name',
        link: '/class/WaterSaving'
      }, {
        label: 'other.name',
        link: '/class/other'
      }]
    } /*,{
        type:'0',
        title:'label15',
        list:[
            {
                label:'label26',
                link:''
            }
        ]
      }*/]);
    return {
      footerData
    };
  }
});